import { CIMSModal } from '..'
import { WorkflowRollbackModalProps } from './types'
import SingleStatusReversal from './components/SingleStatusReversal'
import MultipleStatusReversal from './components/MultipleStatusReversal'

function WorkflowRollbackModal<T = any>({
  visible,
  onClose,
  onOk,
  loading,
  externalForm,
  initialFormValues,
  ...props
}: WorkflowRollbackModalProps<T>) {
  return (
    <CIMSModal
      visible={visible}
      title="Workflow Rollback"
      onCancel={onClose}
      onOk={onOk}
      loading={loading}
      disabled={loading}
      externalForm={externalForm}
      initialFormValues={initialFormValues}
    >
      {props.type === 'multiple' ? (
        <MultipleStatusReversal visible={visible} {...props} />
      ) : (
        <SingleStatusReversal {...props} />
      )}
    </CIMSModal>
  )
}

export default WorkflowRollbackModal
